export default __webpack_public_path__ + "static/media/bkg--enquire.dae47598.png";